import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';


const TopInquiry = ({ date, status, name, isAdmin, space }) => {
  const statusStyleMap = {
    expired: 'text-green-400 bg-green-200',
    pending: 'text-orange-400 bg-orange-150',
    'cancelled by client': 'text-red-600 bg-red-200',
    accepted: 'text-green-400 bg-green-200',
    'declined by space': 'text-red-600 bg-red-200',
    'proposal sent': 'text-green-400 bg-green-200',
    'cancelled by space': 'text-red-600 bg-red-200',
    'pending payment': 'text-orange-400 bg-orange-150',
    paid: 'text-green-400 bg-green-200'
  }
  return (
    <div className="top-inquiry bg-gray-200 flex justify-between items-center p-2 pb-2">
      <span className={`top-inquiry-status px-4 py-1 rounded text-xs font-bold ${statusStyleMap[status]}`}>
        {status && status.toUpperCase()}
      </span>
      <div className="text-center">
        <div className="font-bold text-base text-black">{isAdmin ? 'FlySpaces Space Expert' : name}</div>
        <div className="text-xs">{space}</div>
        {isAdmin && <div className="text-xs">Send us a message and space expert will get back to you shortly!</div>}
      </div>
      <div className={`top-inquiry-date text-right ${isAdmin ? 'invisible' : ''}`}>
        <div className="font-semibold text-xs text-gray-600">{ date ? 'LEAD CREATED ON' : '' }</div>
        <div className="text-xs font-medium text-gray-800">{date ? moment(date).format('MMMM DD, YYYY') : ''}</div>
      </div>
    </div>
  );
}

TopInquiry.propTypes = {
  date: PropTypes.string,
  status: PropTypes.string,
  name: PropTypes.string,
  isAdmin: PropTypes.bool,
  space: PropTypes.string,
};

export default TopInquiry;
